import { render } from "./VirtualMachineInstance.vue?vue&type=template&id=6163b3d6&scoped=true"
import script from "./VirtualMachineInstance.vue?vue&type=script&lang=js"
export * from "./VirtualMachineInstance.vue?vue&type=script&lang=js"

import "./VirtualMachineInstance.vue?vue&type=style&index=0&id=6163b3d6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6163b3d6"]])

export default __exports__